import Layout from '@/layout'

export const routerList = [
  {
    path: '/system',
    component: Layout,
    meta: {
      title: '系统管理',
      icon: 'icon-shezhi-01'
    },
    hidden: false,
    alwaysShow: true,
    children: [
      {
        path: '/system/org',
        component: () => import('@/views/System/Org'),
        name: 'SystemOrg',
        meta: { title: '组织架构', affix: false }
      },
      // {
      //   path: '/system/dept',
      //   component: () => import('@/views/System/Dept'),
      //   name: 'SystemDept',
      //   meta: { title: '部门管理', affix: false }
      // },
      {
        path: '/system/menu',
        component: () => import('@/views/System/Menu'),
        name: 'SystemMenu',
        hidden: false,
        meta: { title: '菜单管理', affix: false },
      },      
      {
        path: '/system/role',
        component: () => import('@/views/System/Role'),
        name: 'SystemRole',
        hidden: false,
        meta: { title: '角色管理', affix: false },
      },
      {
        path: '/system/user',
        component: () => import('@/views/System/User'),
        name: 'SystemUser',
        meta: { title: '员工设置', affix: false }
      },
      {
        path: '/system/announcement',
        component: () => import('@/views/System/Announcement'),
        name: 'SystemAnnouncement',
        meta: { title: '首页公告', affix: false }
      },
      {
        path: '/system/messageSetting',
        component: () => import('@/views/System/MessageSetting'),
        name: 'SystemMessageSetting',
        meta: { title: '消息设置', affix: false }
      },
    ]
  }
]
